import { CognitoIdentityProvider } from '@mesa-labs/mesa-ui';

const cognitoIdentityProvider = new CognitoIdentityProvider({
  region: CONFIG.cognito.region,
  clientId: CONFIG.cognito.clientId,
  userPoolId: CONFIG.cognito.userPoolId,
  // Oauth - currently disabled in vendor-ui
  // AppWebDomain: CONFIG.cognito.oauth.domain,
  // RedirectUriSignIn: CONFIG.cognito.oauth.redirectSignIn,
  // RedirectUriSignOut: CONFIG.cognito.oauth.redirectSignOut,
  // IdentityProvider: CONFIG.cognito.oauth.identityProvider,
});

export default cognitoIdentityProvider;